






























































































































































































































import { LANG } from "@/common/constant";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import { formatImageUrl, getAttributeByLangSnakeCase } from "@/common/utils";
import { DEFAULT_IMAGES } from "@/model/news";
import $ from "jquery";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "NewsPreviewComponent",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
  },
})
export default class NewsPreviewComponent extends Vue {
  public news: any = {};
  public async mounted() {
    const news = localStorage.getItem("news");
    this.news = JSON.parse(news);
    this.$nextTick(() => {
      $(".QuillArea iframe.ql-video").each(function() {
        if (!$(this).parent().is("div.mb__movie-wrap")) {
          const newDiv = $('<div class="mb__movie-wrap">');
          $(this).wrap(newDiv);
        }
      });
    });
  }

  public getDefaultThumbnailUrl(thumbnailNo) {
    return "/images/default/" + DEFAULT_IMAGES[thumbnailNo];
  }

  public imageUrl(name) {
    return formatImageUrl(name, "768x432");
  }

  public getContentByLang(object, attributeName) {
    if (this.$route.query.lang) {
      return getAttributeByLangSnakeCase(
        object,
        attributeName,
        this.$route.query.lang,
      );
    }

    return getAttributeByLangSnakeCase(object, attributeName, LANG.JA);
  }

  public translateAttribute(attributeName) {
    const currentLang = this.$route.query.lang ? this.$route.query.lang : LANG.JA;
    return this.$t(attributeName, `${currentLang}`);
  }
}
